import { getReadingLevel, type ReadingLevelProgress } from '../domain/readingLevel';
import { statisticsService } from './statisticsService';

export const LEVEL_UP_EVENT = 'leitour:level-up';

export type LevelUpEventDetail = Pick<ReadingLevelProgress, 'currentLevel' | 'totalMinutes'>;

const readEligibleDuration = async (): Promise<number | undefined> => {
  try {
    return (await statisticsService.get('total')).durationMs;
  } catch {
    return undefined;
  }
};

const announceLevelUp = (detail: LevelUpEventDetail): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<LevelUpEventDetail>(LEVEL_UP_EVENT, { detail }));
};

export const saveWithLevelUpDetection = async <Result>(save: () => Promise<Result>): Promise<Result> => {
  const beforeDurationMs = await readEligibleDuration();
  const result = await save();
  if (beforeDurationMs === undefined) return result;

  const afterDurationMs = await readEligibleDuration();
  if (afterDurationMs === undefined) return result;

  const previous = getReadingLevel(beforeDurationMs);
  const current = getReadingLevel(afterDurationMs);
  if (current.currentLevel > previous.currentLevel) {
    announceLevelUp({ currentLevel: current.currentLevel, totalMinutes: current.totalMinutes });
  }
  return result;
};
